import React, { Fragment, useEffect, useLayoutEffect, useState, useCallback, useRef } from 'react';
import ReactGA from 'react-ga4'
import axios from 'axios'

import FileList from 'components/Course/FileList';
import InfoCard from 'components/Course/InfoCard';
import InfoModal from 'components/Modal/InfoModal';
import VideoPlayerModal from 'components/Video/VideoPlayerModal';
import modalText from 'constants/modalTexts/authContent';
import { useSelector } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import FileService from 'services/file';
import SchoolService from 'services/school';//Don't remove
import { ContentSteeringController } from 'hls.js';


const CourseContent = (props) => {
	const [lessons, setLessons] = useState(null)
	const [videoPlayerOpen, setVideoPlayerOpen] = useState(false)
	const [videoLink, setVideoLink] = useState(null)
	const [fileType, setFileType] = useState('video')
	const [modalExtraMessage, setModalExtraMessage] = useState(null)
	const [infoModalVisible, setInfoModalVisible] = useState(false)
	const scrollRef = useRef(null)
	const { id } = useParams()
	const authState = useSelector((state) => state.auth.token)
	const location = useLocation()

	const lessonId = location.state ? location.state.lessonId : null
	const videoId = location.state ? location.state.playVideoId : null
	const pdfId = location.state ? location.state.openPdfId : null
	const formlinkId = location.state ? location.state.openFormlinkId : null

	const auth = lessonId || videoId || pdfId || formlinkId ? location.state.ref : authState

	//Can this be here?
	const playRef = location.state ? location.state.ref : null


	useEffect(() => {
		const getLessons = async (id) => {
			try {
				const res = await SchoolService.getLessonsByCourseContent(id);

				//console.log('Got lessons', res.records)
				//console.log('lessonId', lessonId, 'videoId', videoId, 'pdfId', pdfId, 'openFormlinkId', openFormlinkId)


				setLessons(res.records);
			} catch (e) { }
		}
		setModalExtraMessage(null)
		getLessons(id)
	}, [id])

	async function handleAuthenticatedVideo(id, videoRef) {
		//const { record: { filnamn__c } } = await SchoolService.getAssignment(id);
		await FileService.getSignedCookie(videoRef);
		const { url, title } = await FileService.getSignedUrlVideo_GET(id, null, videoRef);
		const videoTitle = title || 'unknown';
		// We get 204 and no content if video cannot be found (due to behaviour in admin)
		if (!url) {
			showModal('noContent');
			return null;
		}
		setVideoLink(url);
		setVideoPlayerOpen(true);
		return videoTitle;
	}

	// If ref is sent to get cookie, BE will lookup to see if this is an actively shared direct link to play
	const playVideo = useCallback(
		//async (id, lessonAccess, videoRef = null) => {
		async (id, lessonAccess) => {
			let successPlay = 'Ok'
			let videoTitle
			try {
				if (lessonAccess) {
					console.log('Playing video with lesson access')
					// Here we send the auth (which should be same as videoref)
					const { url } = await FileService.getSignedUrlVideo_GET(id, null, auth);
					setVideoLink(url);
					setVideoPlayerOpen(true)
				}
				else if (auth && playRef && videoId === id) {
					console.log('Playing video with direct link')
					//Any 5 length ref will unfortunately do here
					videoTitle = await handleAuthenticatedVideo(id, playRef);
					if (videoTitle === null) {
						console.error('Could not get video')
						return;
					}
				}
				else if (auth && auth.length !== 5) {
					//videoTitle = await handleAuthenticatedVideo(id, videoRef);
					videoTitle = await handleAuthenticatedVideo(id, playRef);
					if (videoTitle === null) {
						console.error('Could not get video')
						return;
					}
				}
				else {
					setInfoModalVisible(true)
					successPlay = 'Not logged in'
				}
			} catch (error) {
				console.error('ERROR', error)
				if (error.response && error.response.status === 401) {
					await showModal('notSubscribed', error.response.data.message);
				} else {
					await showModal('unknownVideoError');
				}
			} finally {
				ReactGA.event({
					category: 'Video',
					action: 'Clicked play',
					label: videoTitle + '. Success: ' + successPlay,
				});
			}
		},
		[auth]
	);

	const showModal = async (fileType, extraMessage = null) => {
		setFileType(fileType);
		setModalExtraMessage(extraMessage);
		setInfoModalVisible(true);
	};

	// Only for direct links
	const getlinkAndOpenForm = async () => {
		//console.log('getting form url')
		try {
			const res = await SchoolService.getAssignment(formlinkId);
			const url = res?.record?.formlink_url__c
			const name = res?.record?.name || 'Formulär'
			if (!url) {
				console.error('Did not get url for formlink')
			} else {
				showFormLink(formlinkId, name, url, false)
			}
		} catch (e) {
			console.error('ERROR opening form from link', e)
		}
	}


	let videoPlayer = null;
	if (videoLink) {
		videoPlayer = (
			<VideoPlayerModal
				link={videoLink}
				isOpen={videoPlayerOpen}
				toggle={() => setVideoPlayerOpen((old) => !old)}
				course={props.course}
				style={{ 'maxWidth': '570px' }}
				area={props.area}
			/>
		);
	}

	const createLinkAndClick = (url, title) => {
		axios({
			url: url,
			method: 'GET',
			responseType: 'blob', // important
		}).then((response) => {
			// create file link in browser's memory
			const href = URL.createObjectURL(new Blob([response.data]));
			// create "a" HTML element with href to file & click
			const link = document.createElement('a')
			link.href = href
			link.setAttribute('download', title || 'uppgift.pdf')
			link.target = '_blank'
			document.body.appendChild(link)
			//window.open(href)
			link.click()
			// clean up "a" element & remove ObjectURL
			document.body.removeChild(link)
			URL.revokeObjectURL(href)

		})
	}

	//const showPdf = async (id, title, lessonAccess, pdfRef = null) => {
	const showPdf = async (id, title, lessonAccess, isAutoOpen = false) => {
		let successFetch = 'Ok'
		setFileType('pdf')
		setModalExtraMessage(null)
		try {
			if (lessonAccess) {
				console.log('pdf with lessonaccess')
				const res = await FileService.getSignedUrlpdfValidated_GET(id, title, auth)
				if (!res.url) {
					throw new Error('Ingen url')
				} else {
					// window.open(res.url)
					// Here, instead use hack for some browsers
					createLinkAndClick(res.url, title)
				}

				//Behöver hämta title här, eller skicka med
				//} else if (auth && title && pdfRef) {
			} else if (auth && title && playRef && pdfId === id) {
				console.log('Showing pdf from direct link')
				//console.log('auth', auth, 'title', title, 'id', id, 'pdfRef', playRef)
				const res = await FileService.getSignedUrlpdfValidated_GET(id, title, auth)
				//console.log('response from getsignedurlpdf', res)
				if (!res.url || !res.filename) {
					console.log('Ingen url eller filnamn')
					throw new Error('Ingen url')
				} else {
					// If isAutoOpen is true, we open the pdf in a new tab
					if (isAutoOpen) {
						console.log('Auto-open pdf')
						window.open(res.url, '_blank')
					} else {
						// Else this for direct links, so ios users can click and open
						createLinkAndClick(res.url, title)
					}
				}


			} else if (auth && auth.length !== 5) {
				console.log('pdf normal fetch with playvideo auth')
				const res = await FileService.getSignedUrlpdfValidated_GET(id, title)
				if (!res.url) {
					throw new Error('Ingen url')
				} else {
					createLinkAndClick(res.url, title)
				}
			} else {
				console.log('Kunde inte öppna pdf')
				setInfoModalVisible(true)
				successFetch = 'Not logged in'
				return
			}
		} catch (e) {
			if (e.response && e.response.status === 401) {
				let msg = null
				if (e.response && e.response.data && e.response.data.message) { console.log(e.response.data.message); msg = e.response.data.message }
				setFileType('notSubscribed')
				setModalExtraMessage(msg)
			} else {
				setFileType('noContent');
				successFetch = 'Could not fetch'
			}
			setInfoModalVisible(true);
		} finally {
			ReactGA.event({
				category: 'PDF',
				action: 'Clicked download PDF',
				label: (title ? title : 'Unkown') + '. Success: ' + successFetch,
			})
		}
	}

	const showFormLink = async (id, title, url, lessonAccess) => {
		//console.log('opening link, lessonAccess', lessonAccess, 'url', url, 'title', title)

		setFileType('formlink')
		setModalExtraMessage(null)

		try {
			if (url && lessonAccess) {
				console.log('Open form with lesson access')
				// Here we send the auth (which should be same as videoref)
				window.open(url)
			} else if (auth && url && playRef && formlinkId === id) {
				console.log('Opening form with direct link')
				window.open(url)
			} else if (url && auth && auth.length !== 5) {
				console.log('Opening form with normal auth')
				const res = await FileService.getAuthPlayVideo(id);
				//console.log('check auth response', res)
				//createLinkAndClick(url, title) // can't bc CORS, need CNAME stuff for this
				window.open(url)
			} else if (!url) {
				setFileType('noContent');
				setInfoModalVisible(true);
			} else {
				setInfoModalVisible(true);
			}
		} catch (error) {
			console.error('ERROR', error)
			if (error.response && error.response.status === 401) {
				await showModal('notSubscribed', error.response.data.message);
			} else {
				await showModal('unknownVideoError');
			}
		} finally {
			ReactGA.event({
				category: 'FormLink',
				action: 'Clicked open formlink',
				label: (title ? title : 'Unkown')
			})

			//Create stats
			try {
				await FileService.formlinkPing(id);
			} catch (e) {
				console.error('Formlink ping ERROR', e)
			}

		}
	}

	//This is for auto actions using direct links
	//useEffect(() => {
	useLayoutEffect(() => {
		// It is possible to send ref and spela as params, but then menu will not update.
		// If history pushed from /video/xxx, these params are instead sent as location state
		//console.log('How often here?')
		//console.log('What to do, videoId', videoId, 'pdfId', pdfId, 'formlinkId', formlinkId, 'playRef', playRef)

		const doAction = async () => {
			const lessonAccess = false

			if (videoId && playRef) {
				console.log('playVideo id', videoId)
				playVideo(videoId, lessonAccess)
				//} else if (playId && ref) {
				//	console.log('playId. Ever here??', playId)
				//	playVideo(playId, lessonAccess, ref)
			} else if (pdfId && playRef) {
				console.log('pdfId', pdfId)
				showPdf(pdfId, 'dokument.pdf', lessonAccess, true);
			} else if (formlinkId && playRef) {
				console.log('formlinkId', formlinkId)
				// Get the url from assignemnt first
				getlinkAndOpenForm()
			}
		}


		doAction()

	}, [])




	useEffect(() => {
		if (scrollRef.current) {
			scrollRef.current.scrollIntoView({ behavior: 'smooth' })
		}
	}, [lessons])


	let fileLists = null;
	if (lessons) {
		fileLists = lessons.map((el) => {
			const lessonAccess = lessonId === el.id
			const lessonNoAccess = lessonId && lessonId !== el.id
			const lessonRef = lessonAccess ? scrollRef : null
			const isExamination = el.tags__c && el.tags__c.includes('examination')
			return (
				<Fragment key={`${el.id}`}>
					<div ref={lessonRef}>
						<Row>
							<Col md="6">
								<FileList
									teacher={el.teacher__c}
									showPdf={showPdf}
									playVideo={playVideo}
									showFormLink={showFormLink}
									title={el.name}
									lessonID={el.id}
									lessonAccess={lessonAccess}
									lessonNoAccess={lessonNoAccess}
									isExamination={isExamination}
									onlyShowAssignmentId={videoId || pdfId || formlinkId || null}
								/>
							</Col>
							<Col md="6">
								<InfoCard longinfo={el.description__c} title={"Beskrivning"} />
							</Col>
						</Row>
					</div>
				</Fragment>
			);
		});
	}

	return (
		<Fragment>
			<Container fluid>
				<InfoModal
					toggle={() => setInfoModalVisible((old) => !old)}
					show={infoModalVisible}
					text={{
						title: modalText[fileType] ? modalText[fileType].title : 'Ett fel uppstod',
						text: modalText[fileType] ? modalText[fileType].text : 'Ett fel uppstod',
						extraMsg: modalExtraMessage
					}}
				/>
				<InfoCard longinfo={props.areaDescription} title={'Beskrivning'} topinfo={true} />
				{videoPlayer}
				{fileLists}
			</Container>
		</Fragment>
	);
};

export default CourseContent;
